import { apiClient } from './api'
import type { ApiResponse } from '@/types/api'
import type {
  Attendance,
  RecordAttendanceInput,
  BulkAttendanceInput,
  AttendanceSummary,
  UpdateAttendanceInput,
} from '@/types/attendance'

export const attendanceService = {
  /**
   * Record attendance for a student in a session
   */
  recordAttendance: async (
    sessionId: string,
    input: RecordAttendanceInput
  ): Promise<ApiResponse<Attendance>> => {
    return apiClient.post('/attendance', { ...input, sessionId })
  },

  /**
   * Record attendance for multiple students in a session
   */
  bulkRecordAttendance: async (
    sessionId: string,
    input: BulkAttendanceInput
  ): Promise<ApiResponse<Attendance[]>> => {
    return apiClient.post('/attendance/bulk', { ...input, sessionId })
  },

  /**
   * Get all attendance records for a session
   */
  getSessionAttendance: async (sessionId: string): Promise<ApiResponse<Attendance[]>> => {
    return apiClient.get(`/attendance/session/${sessionId}`)
  },

  /**
   * Get attendance records for a specific student in a batch
   */
  getStudentAttendance: async (
    batchId: string,
    studentId: string
  ): Promise<ApiResponse<Attendance[]>> => {
    return apiClient.get(`/attendance/batch/${batchId}/student/${studentId}`)
  },

  /**
   * Get attendance summary for a batch
   */
  getBatchAttendanceSummary: async (
    batchId: string
  ): Promise<ApiResponse<AttendanceSummary>> => {
    return apiClient.get(`/attendance/batch/${batchId}/summary`)
  },

  /**
   * Update an existing attendance record
   */
  updateAttendance: async (
    id: string,
    input: UpdateAttendanceInput
  ): Promise<ApiResponse<void>> => {
    return apiClient.put(`/attendance/${id}`, input)
  },
}
